// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: u60ZC-igoF

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicAudioItem.module.css"; // plasmic-import: u60ZC-igoF/css

import IconsPlayIcon from "./icons/PlasmicIcon__IconsPlay"; // plasmic-import: iEHTUbtGu7/icon
import IconsDeleteIcon from "./icons/PlasmicIcon__IconsDelete"; // plasmic-import: svOIRRDbImq/icon
import ArchiveCheckIcon from "./icons/PlasmicIcon__ArchiveCheck"; // plasmic-import: 9Z0WKABde/icon
import IconsSourcesSavedForLaterIcon from "./icons/PlasmicIcon__IconsSourcesSavedForLater"; // plasmic-import: sGge8vvbDB/icon
import MenuIconIcon from "./icons/PlasmicIcon__MenuIcon"; // plasmic-import: 6ypUPjJsyj/icon

createPlasmicElementProxy;

export type PlasmicAudioItem__VariantMembers = {
  type: "track" | "episode";
  availableWidth: "list" | "grid";
};
export type PlasmicAudioItem__VariantsArgs = {
  type?: SingleChoiceArg<"track" | "episode">;
  availableWidth?: SingleChoiceArg<"list" | "grid">;
};
type VariantPropType = keyof PlasmicAudioItem__VariantsArgs;
export const PlasmicAudioItem__VariantProps = new Array<VariantPropType>(
  "type",
  "availableWidth"
);

export type PlasmicAudioItem__ArgsType = {
  name?: React.ReactNode;
  author?: React.ReactNode;
  description?: React.ReactNode;
};
type ArgPropType = keyof PlasmicAudioItem__ArgsType;
export const PlasmicAudioItem__ArgProps = new Array<ArgPropType>(
  "name",
  "author",
  "description"
);

export type PlasmicAudioItem__OverridesType = {
  root?: p.Flex<"div">;
  card?: p.Flex<"div">;
  imageContainer?: p.Flex<"div">;
  image?: p.Flex<typeof p.PlasmicImg>;
  data?: p.Flex<"div">;
  nameContainer?: p.Flex<"div">;
  authorContainer?: p.Flex<"button">;
  descriptionContainer?: p.Flex<"div">;
  datePublished?: p.Flex<"div">;
  duration?: p.Flex<"div">;
  iconStack?: p.Flex<"div">;
  deleteButton?: p.Flex<"button">;
  archiveButton?: p.Flex<"button">;
  saveForLaterButton?: p.Flex<"button">;
  menuButton?: p.Flex<"button">;
};

export interface DefaultAudioItemProps {
  name?: React.ReactNode;
  author?: React.ReactNode;
  description?: React.ReactNode;
  type?: SingleChoiceArg<"track" | "episode">;
  availableWidth?: SingleChoiceArg<"list" | "grid">;
  className?: string;
}

const $$ = {};

function PlasmicAudioItem__RenderFunc(props: {
  variants: PlasmicAudioItem__VariantsArgs;
  args: PlasmicAudioItem__ArgsType;
  overrides: PlasmicAudioItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type
      },
      {
        path: "availableWidth",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.availableWidth
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover
  };

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootavailableWidth_list]: hasVariant(
            $state,
            "availableWidth",
            "list"
          ),
          [sty.roottype_episode]: hasVariant($state, "type", "episode"),
          [sty.roottype_episode_availableWidth_list]:
            hasVariant($state, "type", "episode") &&
            hasVariant($state, "availableWidth", "list"),
          [sty.roottype_track]: hasVariant($state, "type", "track"),
          [sty.roottype_track_availableWidth_list]:
            hasVariant($state, "type", "track") &&
            hasVariant($state, "availableWidth", "list")
        }
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <div
        data-plasmic-name={"card"}
        data-plasmic-override={overrides.card}
        className={classNames(projectcss.all, sty.card, {
          [sty.cardavailableWidth_list]: hasVariant(
            $state,
            "availableWidth",
            "list"
          ),
          [sty.cardtype_episode]: hasVariant($state, "type", "episode"),
          [sty.cardtype_episode_availableWidth_list]:
            hasVariant($state, "type", "episode") &&
            hasVariant($state, "availableWidth", "list"),
          [sty.cardtype_track]: hasVariant($state, "type", "track"),
          [sty.cardtype_track_availableWidth_list]:
            hasVariant($state, "type", "track") &&
            hasVariant($state, "availableWidth", "list")
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox___9U2Dl, {
            [sty.freeBoxtype_episode___9U2Dlstgjw]: hasVariant(
              $state,
              "type",
              "episode"
            ),
            [sty.freeBoxtype_track___9U2DldbLav]: hasVariant(
              $state,
              "type",
              "track"
            )
          })}
        >
          <div
            data-plasmic-name={"imageContainer"}
            data-plasmic-override={overrides.imageContainer}
            className={classNames(projectcss.all, sty.imageContainer, {
              [sty.imageContaineravailableWidth_list]: hasVariant(
                $state,
                "availableWidth",
                "list"
              ),
              [sty.imageContainertype_episode]: hasVariant(
                $state,
                "type",
                "episode"
              ),
              [sty.imageContainertype_episode_availableWidth_list]:
                hasVariant($state, "type", "episode") &&
                hasVariant($state, "availableWidth", "list"),
              [sty.imageContainertype_track]: hasVariant(
                $state,
                "type",
                "track"
              )
            })}
          >
            <p.PlasmicImg
              data-plasmic-name={"image"}
              data-plasmic-override={overrides.image}
              alt={""}
              className={classNames(sty.image, {
                [sty.imageavailableWidth_list]: hasVariant(
                  $state,
                  "availableWidth",
                  "list"
                ),
                [sty.imagetype_episode]: hasVariant($state, "type", "episode"),
                [sty.imagetype_episode_availableWidth_list]:
                  hasVariant($state, "type", "episode") &&
                  hasVariant($state, "availableWidth", "list"),
                [sty.imagetype_track]: hasVariant($state, "type", "track")
              })}
              displayHeight={"100%"}
              displayMaxHeight={"none"}
              displayMaxWidth={"none"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"100%"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://img.plasmic.app/img-optimizer/v1/img/e7bc9cfe679800c67393139cca0322c9.png",
                fullWidth: 630,
                fullHeight: 636
              }}
            />
          </div>
          <IconsPlayIcon
            className={classNames(projectcss.all, sty.svg__qt4Gc, {
              [sty.svgtype_episode__qt4Gcstgjw]: hasVariant(
                $state,
                "type",
                "episode"
              ),
              [sty.svgtype_episode_availableWidth_list__qt4GcstgjwRQvKy]:
                hasVariant($state, "type", "episode") &&
                hasVariant($state, "availableWidth", "list"),
              [sty.svgtype_track__qt4GcdbLav]: hasVariant(
                $state,
                "type",
                "track"
              ),
              [sty.svgtype_track_availableWidth_list__qt4GcdbLavRQvKy]:
                hasVariant($state, "type", "track") &&
                hasVariant($state, "availableWidth", "list")
            })}
            role={"img"}
          />
        </div>
        <p.Stack
          as={"div"}
          data-plasmic-name={"data"}
          data-plasmic-override={overrides.data}
          hasGap={true}
          className={classNames(projectcss.all, sty.data, {
            [sty.dataavailableWidth_list]: hasVariant(
              $state,
              "availableWidth",
              "list"
            ),
            [sty.datatype_episode]: hasVariant($state, "type", "episode"),
            [sty.datatype_episode_availableWidth_list]:
              hasVariant($state, "type", "episode") &&
              hasVariant($state, "availableWidth", "list"),
            [sty.datatype_track]: hasVariant($state, "type", "track")
          })}
        >
          <p.Stack
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__fr1HO, {
              [sty.freeBoxavailableWidth_list__fr1HOrQvKy]: hasVariant(
                $state,
                "availableWidth",
                "list"
              ),
              [sty.freeBoxtype_episode__fr1HOstgjw]: hasVariant(
                $state,
                "type",
                "episode"
              ),
              [sty.freeBoxtype_episode_availableWidth_list__fr1HOstgjwRQvKy]:
                hasVariant($state, "type", "episode") &&
                hasVariant($state, "availableWidth", "list"),
              [sty.freeBoxtype_track__fr1HOdbLav]: hasVariant(
                $state,
                "type",
                "track"
              )
            })}
          >
            <div
              data-plasmic-name={"nameContainer"}
              data-plasmic-override={overrides.nameContainer}
              className={classNames(projectcss.all, sty.nameContainer, {
                [sty.nameContaineravailableWidth_list]: hasVariant(
                  $state,
                  "availableWidth",
                  "list"
                ),
                [sty.nameContainertype_episode]: hasVariant(
                  $state,
                  "type",
                  "episode"
                ),
                [sty.nameContainertype_episode_availableWidth_list]:
                  hasVariant($state, "type", "episode") &&
                  hasVariant($state, "availableWidth", "list"),
                [sty.nameContainertype_track]: hasVariant(
                  $state,
                  "type",
                  "track"
                ),
                [sty.nameContainertype_track_availableWidth_list]:
                  hasVariant($state, "type", "track") &&
                  hasVariant($state, "availableWidth", "list")
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents:
                  "Brandenburg Concerto Nr 5 in D, BVW 1050: 1. Allegro Brandenburg Concerto Nr 5 in D, BVW 1050: 1. Allegro  Brandenburg Concerto Nr 5 in D, BVW 1050: 1. Allegro ",
                value: args.name,
                className: classNames(sty.slotTargetName, {
                  [sty.slotTargetNameavailableWidth_list]: hasVariant(
                    $state,
                    "availableWidth",
                    "list"
                  ),
                  [sty.slotTargetNametype_episode]: hasVariant(
                    $state,
                    "type",
                    "episode"
                  ),
                  [sty.slotTargetNametype_episode_availableWidth_list]:
                    hasVariant($state, "type", "episode") &&
                    hasVariant($state, "availableWidth", "list"),
                  [sty.slotTargetNametype_track]: hasVariant(
                    $state,
                    "type",
                    "track"
                  ),
                  [sty.slotTargetNametype_track_availableWidth_list]:
                    hasVariant($state, "type", "track") &&
                    hasVariant($state, "availableWidth", "list")
                })
              })}
            </div>
            <button
              data-plasmic-name={"authorContainer"}
              data-plasmic-override={overrides.authorContainer}
              className={classNames(
                projectcss.all,
                projectcss.button,
                sty.authorContainer,
                {
                  [sty.authorContainertype_episode]: hasVariant(
                    $state,
                    "type",
                    "episode"
                  )
                }
              )}
              ref={ref => {
                $refs["authorContainer"] = ref;
              }}
            >
              {p.renderPlasmicSlot({
                defaultContents:
                  "Johann Sebastian Back, English Chamber Orchestra",
                value: args.author,
                className: classNames(sty.slotTargetAuthor, {
                  [sty.slotTargetAuthortype_episode]: hasVariant(
                    $state,
                    "type",
                    "episode"
                  )
                })
              })}
            </button>
            {(hasVariant($state, "type", "episode") ? true : false) ? (
              <div
                data-plasmic-name={"descriptionContainer"}
                data-plasmic-override={overrides.descriptionContainer}
                className={classNames(
                  projectcss.all,
                  sty.descriptionContainer,
                  {
                    [sty.descriptionContainertype_episode]: hasVariant(
                      $state,
                      "type",
                      "episode"
                    ),
                    [sty.descriptionContainertype_episode_availableWidth_list]:
                      hasVariant($state, "type", "episode") &&
                      hasVariant($state, "availableWidth", "list")
                  }
                )}
              >
                {p.renderPlasmicSlot({
                  defaultContents:
                    "In this episode, John and Peter talk about the joy of sniffing their own fars and what foods constitute the best flavours. In this episode, John and Peter talk about the joy of sniffing their own fars and what foods constitute the best flavours. In this episode, John and Peter talk about the joy of sniffing their own fars and what foods constitute the best flavours.",
                  value: args.description,
                  className: classNames(sty.slotTargetDescription, {
                    [sty.slotTargetDescriptiontype_episode]: hasVariant(
                      $state,
                      "type",
                      "episode"
                    ),
                    [sty.slotTargetDescriptiontype_episode_availableWidth_list]:
                      hasVariant($state, "type", "episode") &&
                      hasVariant($state, "availableWidth", "list")
                  })
                })}
              </div>
            ) : null}
          </p.Stack>
          <p.Stack
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox___3I15C, {
              [sty.freeBoxtype_episode___3I15Cstgjw]: hasVariant(
                $state,
                "type",
                "episode"
              ),
              [sty.freeBoxtype_episode_availableWidth_list___3I15CstgjwRQvKy]:
                hasVariant($state, "type", "episode") &&
                hasVariant($state, "availableWidth", "list")
            })}
          >
            <div
              data-plasmic-name={"datePublished"}
              data-plasmic-override={overrides.datePublished}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.datePublished,
                {
                  [sty.datePublishedtype_episode]: hasVariant(
                    $state,
                    "type",
                    "episode"
                  )
                }
              )}
            >
              {"March 17 - 2022"}
            </div>
            <div
              data-plasmic-name={"duration"}
              data-plasmic-override={overrides.duration}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.duration,
                {
                  [sty.durationtype_episode]: hasVariant(
                    $state,
                    "type",
                    "episode"
                  )
                }
              )}
            >
              {"52min 34s"}
            </div>
          </p.Stack>
        </p.Stack>
        <div
          className={classNames(projectcss.all, sty.freeBox__auK8G, {
            [sty.freeBoxtype_episode__auK8Gstgjw]: hasVariant(
              $state,
              "type",
              "episode"
            ),
            [sty.freeBoxtype_episode_availableWidth_list__auK8GstgjwRQvKy]:
              hasVariant($state, "type", "episode") &&
              hasVariant($state, "availableWidth", "list"),
            [sty.freeBoxtype_track__auK8GdbLav]: hasVariant(
              $state,
              "type",
              "track"
            ),
            [sty.freeBoxtype_track_availableWidth_list__auK8GdbLavRQvKy]:
              hasVariant($state, "type", "track") &&
              hasVariant($state, "availableWidth", "list")
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__wZzb2, {
              [sty.freeBoxtype_episode__wZzb2Stgjw]: hasVariant(
                $state,
                "type",
                "episode"
              ),
              [sty.freeBoxtype_episode_availableWidth_list__wZzb2StgjwRQvKy]:
                hasVariant($state, "type", "episode") &&
                hasVariant($state, "availableWidth", "list"),
              [sty.freeBoxtype_track__wZzb2DbLav]: hasVariant(
                $state,
                "type",
                "track"
              ),
              [sty.freeBoxtype_track_availableWidth_list__wZzb2DbLavRQvKy]:
                hasVariant($state, "type", "track") &&
                hasVariant($state, "availableWidth", "list")
            })}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"iconStack"}
              data-plasmic-override={overrides.iconStack}
              hasGap={true}
              className={classNames(projectcss.all, sty.iconStack, {
                [sty.iconStackavailableWidth_list]: hasVariant(
                  $state,
                  "availableWidth",
                  "list"
                ),
                [sty.iconStacktype_episode]: hasVariant(
                  $state,
                  "type",
                  "episode"
                ),
                [sty.iconStacktype_episode_availableWidth_list]:
                  hasVariant($state, "type", "episode") &&
                  hasVariant($state, "availableWidth", "list"),
                [sty.iconStacktype_track]: hasVariant($state, "type", "track"),
                [sty.iconStacktype_track_availableWidth_list]:
                  hasVariant($state, "type", "track") &&
                  hasVariant($state, "availableWidth", "list")
              })}
            >
              <button
                data-plasmic-name={"deleteButton"}
                data-plasmic-override={overrides.deleteButton}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  sty.deleteButton,
                  {
                    [sty.deleteButtontype_episode_availableWidth_list]:
                      hasVariant($state, "type", "episode") &&
                      hasVariant($state, "availableWidth", "list"),
                    [sty.deleteButtontype_track_availableWidth_list]:
                      hasVariant($state, "type", "track") &&
                      hasVariant($state, "availableWidth", "list")
                  }
                )}
                ref={ref => {
                  $refs["deleteButton"] = ref;
                }}
              >
                <IconsDeleteIcon
                  className={classNames(projectcss.all, sty.svg__uMhKb, {
                    [sty.svgtype_episode_availableWidth_list__uMhKbStgjwRQvKy]:
                      hasVariant($state, "type", "episode") &&
                      hasVariant($state, "availableWidth", "list"),
                    [sty.svgtype_track_availableWidth_list__uMhKbDbLavRQvKy]:
                      hasVariant($state, "type", "track") &&
                      hasVariant($state, "availableWidth", "list")
                  })}
                  role={"img"}
                />
              </button>
              {(
                hasVariant($state, "type", "episode") &&
                hasVariant($state, "availableWidth", "list") &&
                triggers.hover_root
                  ? true
                  : hasVariant($state, "type", "track") &&
                    hasVariant($state, "availableWidth", "list") &&
                    triggers.hover_root
                  ? true
                  : false
              ) ? (
                <button
                  data-plasmic-name={"archiveButton"}
                  data-plasmic-override={overrides.archiveButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.archiveButton,
                    {
                      [sty.archiveButtontype_episode_availableWidth_list]:
                        hasVariant($state, "type", "episode") &&
                        hasVariant($state, "availableWidth", "list"),
                      [sty.archiveButtontype_track_availableWidth_list]:
                        hasVariant($state, "type", "track") &&
                        hasVariant($state, "availableWidth", "list")
                    }
                  )}
                  ref={ref => {
                    $refs["archiveButton"] = ref;
                  }}
                >
                  <ArchiveCheckIcon
                    className={classNames(projectcss.all, sty.svg__nYMho, {
                      [sty.svgtype_episode_availableWidth_list__nYMhoStgjwRQvKy]:
                        hasVariant($state, "type", "episode") &&
                        hasVariant($state, "availableWidth", "list"),
                      [sty.svgtype_track_availableWidth_list__nYMhoDbLavRQvKy]:
                        hasVariant($state, "type", "track") &&
                        hasVariant($state, "availableWidth", "list")
                    })}
                    role={"img"}
                  />
                </button>
              ) : null}
              {(
                hasVariant($state, "type", "episode") &&
                hasVariant($state, "availableWidth", "list") &&
                triggers.hover_root
                  ? true
                  : hasVariant($state, "type", "track") &&
                    hasVariant($state, "availableWidth", "list") &&
                    triggers.hover_root
                  ? true
                  : false
              ) ? (
                <button
                  data-plasmic-name={"saveForLaterButton"}
                  data-plasmic-override={overrides.saveForLaterButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.saveForLaterButton,
                    {
                      [sty.saveForLaterButtontype_episode_availableWidth_list]:
                        hasVariant($state, "type", "episode") &&
                        hasVariant($state, "availableWidth", "list"),
                      [sty.saveForLaterButtontype_track_availableWidth_list]:
                        hasVariant($state, "type", "track") &&
                        hasVariant($state, "availableWidth", "list")
                    }
                  )}
                  ref={ref => {
                    $refs["saveForLaterButton"] = ref;
                  }}
                >
                  <IconsSourcesSavedForLaterIcon
                    className={classNames(projectcss.all, sty.svg__uBwfM, {
                      [sty.svgtype_episode_availableWidth_list__uBwfMstgjwRQvKy]:
                        hasVariant($state, "type", "episode") &&
                        hasVariant($state, "availableWidth", "list"),
                      [sty.svgtype_track_availableWidth_list__uBwfMdbLavRQvKy]:
                        hasVariant($state, "type", "track") &&
                        hasVariant($state, "availableWidth", "list")
                    })}
                    role={"img"}
                  />
                </button>
              ) : null}
              <button
                data-plasmic-name={"menuButton"}
                data-plasmic-override={overrides.menuButton}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  sty.menuButton,
                  {
                    [sty.menuButtontype_episode]: hasVariant(
                      $state,
                      "type",
                      "episode"
                    ),
                    [sty.menuButtontype_episode_availableWidth_list]:
                      hasVariant($state, "type", "episode") &&
                      hasVariant($state, "availableWidth", "list"),
                    [sty.menuButtontype_track]: hasVariant(
                      $state,
                      "type",
                      "track"
                    ),
                    [sty.menuButtontype_track_availableWidth_list]:
                      hasVariant($state, "type", "track") &&
                      hasVariant($state, "availableWidth", "list")
                  }
                )}
                ref={ref => {
                  $refs["menuButton"] = ref;
                }}
              >
                <MenuIconIcon
                  className={classNames(projectcss.all, sty.svg__vFBn, {
                    [sty.svgtype_episode__vFBnStgjw]: hasVariant(
                      $state,
                      "type",
                      "episode"
                    ),
                    [sty.svgtype_episode_availableWidth_list__vFBnStgjwRQvKy]:
                      hasVariant($state, "type", "episode") &&
                      hasVariant($state, "availableWidth", "list"),
                    [sty.svgtype_track__vFBnDbLav]: hasVariant(
                      $state,
                      "type",
                      "track"
                    ),
                    [sty.svgtype_track_availableWidth_list__vFBnDbLavRQvKy]:
                      hasVariant($state, "type", "track") &&
                      hasVariant($state, "availableWidth", "list")
                  })}
                  role={"img"}
                />
              </button>
            </p.Stack>
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "card",
    "imageContainer",
    "image",
    "data",
    "nameContainer",
    "authorContainer",
    "descriptionContainer",
    "datePublished",
    "duration",
    "iconStack",
    "deleteButton",
    "archiveButton",
    "saveForLaterButton",
    "menuButton"
  ],
  card: [
    "card",
    "imageContainer",
    "image",
    "data",
    "nameContainer",
    "authorContainer",
    "descriptionContainer",
    "datePublished",
    "duration",
    "iconStack",
    "deleteButton",
    "archiveButton",
    "saveForLaterButton",
    "menuButton"
  ],
  imageContainer: ["imageContainer", "image"],
  image: ["image"],
  data: [
    "data",
    "nameContainer",
    "authorContainer",
    "descriptionContainer",
    "datePublished",
    "duration"
  ],
  nameContainer: ["nameContainer"],
  authorContainer: ["authorContainer"],
  descriptionContainer: ["descriptionContainer"],
  datePublished: ["datePublished"],
  duration: ["duration"],
  iconStack: [
    "iconStack",
    "deleteButton",
    "archiveButton",
    "saveForLaterButton",
    "menuButton"
  ],
  deleteButton: ["deleteButton"],
  archiveButton: ["archiveButton"],
  saveForLaterButton: ["saveForLaterButton"],
  menuButton: ["menuButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  card: "div";
  imageContainer: "div";
  image: typeof p.PlasmicImg;
  data: "div";
  nameContainer: "div";
  authorContainer: "button";
  descriptionContainer: "div";
  datePublished: "div";
  duration: "div";
  iconStack: "div";
  deleteButton: "button";
  archiveButton: "button";
  saveForLaterButton: "button";
  menuButton: "button";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAudioItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAudioItem__VariantsArgs;
    args?: PlasmicAudioItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicAudioItem__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicAudioItem__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAudioItem__ArgProps,
          internalVariantPropNames: PlasmicAudioItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAudioItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAudioItem";
  } else {
    func.displayName = `PlasmicAudioItem.${nodeName}`;
  }
  return func;
}

export const PlasmicAudioItem = Object.assign(
  // Top-level PlasmicAudioItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    card: makeNodeComponent("card"),
    imageContainer: makeNodeComponent("imageContainer"),
    image: makeNodeComponent("image"),
    data: makeNodeComponent("data"),
    nameContainer: makeNodeComponent("nameContainer"),
    authorContainer: makeNodeComponent("authorContainer"),
    descriptionContainer: makeNodeComponent("descriptionContainer"),
    datePublished: makeNodeComponent("datePublished"),
    duration: makeNodeComponent("duration"),
    iconStack: makeNodeComponent("iconStack"),
    deleteButton: makeNodeComponent("deleteButton"),
    archiveButton: makeNodeComponent("archiveButton"),
    saveForLaterButton: makeNodeComponent("saveForLaterButton"),
    menuButton: makeNodeComponent("menuButton"),

    // Metadata about props expected for PlasmicAudioItem
    internalVariantProps: PlasmicAudioItem__VariantProps,
    internalArgProps: PlasmicAudioItem__ArgProps
  }
);

export default PlasmicAudioItem;
/* prettier-ignore-end */
